import {
    CREATE_BOOKING_START,
    CREATE_BOOKING_SUCCESS,
    CREATE_BOOKING_ERROR
} from '../../constants';
import { change } from 'redux-form';
import { createUserBooking as mutation } from '../../lib/graphql/booking';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { clearBookingDraft } from '../../helpers/bookingDraft';


export function createBookingAction({ orderId, requestCurrency, reviewDescription, dropOffLocation, dropOffLat, dropOffLng, promoId, paymentType, preferredPartnerId, dispatchMode, scheduledAt, estimatedHours, questionnaire }) {
    return async (dispatch, getState, { client }) => {

        try {
            dispatch({
                type: CREATE_BOOKING_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    orderId,
                    dropOffLocation,
                    dropOffLat,
                    dropOffLng,
                    requestCurrency,
                    promoId,
                    reviewDescription,
                    paymentType,
                    preferredPartnerId,
                    dispatchMode,
                    scheduledAt: scheduledAt ? Number(scheduledAt) : null,
                    estimatedHours: estimatedHours ? Number(estimatedHours) : null,
                    questionnaire: questionnaire || null
                },
            });
            if (data?.createUserBooking?.status === 200) {
                dispatch({
                    type: CREATE_BOOKING_SUCCESS,
                });
                // Resumable booking: the order is placed — drop the persisted draft for this order id.
                clearBookingDraft(orderId);
                // Conversion tracking — auto-fires when the pixels are configured (admin Marketing &
                // Tracking). gtag/fbq exist globally only if injected, so this is a no-op otherwise.
                try {
                    if (typeof window !== 'undefined') {
                        const result = data?.createUserBooking?.result || {};
                        const value = Number(result.userPayableFare || result.totalFare || result.totalAmount || 0);
                        const currency = requestCurrency || 'USD';
                        const transaction_id = result.id;
                        const tk = (getState() && getState().siteSettings && getState().siteSettings.data) || {};
                        if (window.gtag) {
                            if (tk.ga4Id) window.gtag('event', 'purchase', { transaction_id, value, currency });
                            if (tk.googleAdsId && tk.googleAdsLabel) window.gtag('event', 'conversion', { send_to: `${tk.googleAdsId}/${tk.googleAdsLabel}`, value, currency, transaction_id });
                        }
                        if (window.fbq) window.fbq('track', 'Purchase', { value, currency });
                    }
                } catch (e) { /* never break the booking on a tracking error */ }
                await dispatch(change("ConfirmBookingBanner", 'bookingId', data?.createUserBooking?.result?.id));
            } else {
                dispatch({
                    type: CREATE_BOOKING_ERROR,
                    payload: {
                        error: data?.createUserBooking?.errorMessage,
                    },
                });
                let errorMessage = data?.createUserBooking?.errorMessage;
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: errorMessage })
            }
        } catch (error) {
            dispatch({
                type: CREATE_BOOKING_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}